// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_info__BLB77 {
    /*display: flex;*/
    width: 100%;
}

.styles_info__BLB77 img {
    margin-left: -16px;
    width: 16px;
}

.styles_info__BLB77 h5 {
    font-weight: 400;
    display: flex;
    justify-content: space-between;
    grid-gap: 5px;
    margin-bottom: 8px;
    white-space: nowrap;
    max-width: 230px;
    font-size: 14px;
}

.styles_info__BLB77 h5 span:last-child {
    width: 50px;
}

.styles_info__BLB77 h5:last-child {
    border-top: 1px solid #707070;
    margin-top: 20px;
    padding-top: 10px;
}

.styles_title__NFEca {
    display: flex;
    align-items: center;
    grid-gap: 10px;
    /*margin-bottom: 10px;*/
    color: var(--dark-grey);
    /*font-size: 16px;*/
}

.styles_subTitle__wha9E {
}

.styles_iconPlaceholder__4ujco {
    display: inline-block;
    width: 20px;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .styles_info__BLB77 h5 {
        font-size: 16px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_info__BLB77:not(.styles_visible__Byzss) {
        display: none;
    }

    .styles_info__BLB77 h5:last-child {
        margin-top: 7px;
        padding-top: 7px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DealTaxes/components/DealTaxesInfo/styles.module.css"],"names":[],"mappings":"AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;AACA;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":["@value screen-md-max, screen-lg-min from '../../../../breakpoints.css';\n\n.info {\n    /*display: flex;*/\n    width: 100%;\n}\n\n.info img {\n    margin-left: -16px;\n    width: 16px;\n}\n\n.info h5 {\n    font-weight: 400;\n    display: flex;\n    justify-content: space-between;\n    grid-gap: 5px;\n    margin-bottom: 8px;\n    white-space: nowrap;\n    max-width: 230px;\n    font-size: 14px;\n}\n\n.info h5 span:last-child {\n    width: 50px;\n}\n\n.info h5:last-child {\n    border-top: 1px solid #707070;\n    margin-top: 20px;\n    padding-top: 10px;\n}\n\n.title {\n    display: flex;\n    align-items: center;\n    grid-gap: 10px;\n    /*margin-bottom: 10px;*/\n    color: var(--dark-grey);\n    /*font-size: 16px;*/\n}\n\n.subTitle {\n}\n\n.iconPlaceholder {\n    display: inline-block;\n    width: 20px;\n}\n\n@media screen-lg-min {\n    .info h5 {\n        font-size: 16px;\n    }\n}\n\n@media screen-md-max {\n    .info:not(.visible) {\n        display: none;\n    }\n\n    .info h5:last-child {\n        margin-top: 7px;\n        padding-top: 7px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"info": `styles_info__BLB77`,
	"title": `styles_title__NFEca`,
	"subTitle": `styles_subTitle__wha9E`,
	"iconPlaceholder": `styles_iconPlaceholder__4ujco`,
	"visible": `styles_visible__Byzss`
};
export default ___CSS_LOADER_EXPORT___;
